module.exports = __webpack_public_path__ + "static/img/whitelisted_contact_d.5bebf445.svg";